import axiosInstance from "../../../../api/axiosConfig";

export const addStockProduct = (data: any) => {
  return axiosInstance.post("/admin/stock-products", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getStockProduct = (id: string) => {
  return axiosInstance.get(`/admin/stock-products/${id}`);
};

export const updateStockProduct = (id: string, data: any) => {
  return axiosInstance.patch(`/admin/stock-products/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
